import React from 'react'
import { Input } from '@vwfs-bronson/bronson-react'
import { useFormikContext } from 'formik'
import { Select } from '../../../components/Select'
import { FormField } from '../../../components/FormField'
import { phoneCountryCodes, countries } from '../../../resources/base/models'

export const Street = ({ t, index, autocomplete }) => {
  const { values } = useFormikContext()
  const isDisabled = () => {
    return (
      !(values as any)?.addresses?.[index]?.isManual &&
      !(values as any)?.addresses?.[index]?.city
    )
  }
  return (
    <FormField
      testId="street"
      type="input"
      name={`addresses[${index}].street`}
      labelText={t('contact-details:street')}
      render={(fieldProps) => (
        <Input {...fieldProps} disabled={isDisabled()} autocomplete={isDisabled() ? "off" : autocomplete} aria-describedby={`error-${fieldProps.name}`} id={fieldProps.name} required />
      )}
    />
  )
}

export const HouseNumber = ({ t, index, autocomplete }) => {
  const { values } = useFormikContext()
  const isDisabled = () => {
    return (
      !(values as any)?.addresses?.[index]?.isManual &&
      !(values as any)?.addresses?.[index]?.streetSelected
    )
  }
  return (
    <FormField
      testId="houseNumber"
      type="input"
      name={`addresses[${index}].houseNumber`}
      labelText={t('contact-details:houseNumber')}
      render={(fieldProps) => (
        <Input {...fieldProps} disabled={isDisabled()} autocomplete={isDisabled() ? "off" : autocomplete} aria-describedby={`error-${fieldProps.name}`} id={fieldProps.name} required />
      )}
    />
  )
}

export const ZipCode = ({ t, index, autocomplete }) => (
  <FormField
    testId="zipCode"
    type="input"
    name={`addresses[${index}].zipCode`}
    labelText={t('contact-details:zipCode')}
    render={(fieldProps) => <Input {...fieldProps} autocomplete={autocomplete} aria-describedby={`error-${fieldProps.name}`} id={fieldProps.name} required />}
  />
)

export const City = ({ t, index, autocomplete }) => {
  const { values } = useFormikContext()
  const isManual = (values as any)?.addresses?.[index]?.isManual
  return (
    <FormField
      testId="city"
      type="input"
      name={`addresses[${index}].city`}
      labelText={t('contact-details:city')}
      infoIcon={t('contact-details:city_tooltip')}
      ariaLabelInfoIcon={t('contact-details:city_tooltip_title')}
      render={(fieldProps) => (
        <Input {...fieldProps} disabled={!isManual} autocomplete={isManual ? autocomplete : "off"} aria-describedby={`error-${fieldProps.name}`} id={fieldProps.name} required />
      )}
    />
  )
}
export const CountryCode = ({ t, index }) => (
  <FormField
    testId="countryCode"
    type="select"
    name={`addresses[${index}].countryCode`}
    labelText={t('contact-details:countryCode')}
    render={(fieldProps) => (
      <Select
        defaultOption
        values={countries}
        {...fieldProps}
        autocomplete="country"
        required
      >
        {countries?.map(({ value, label }) => (
          <Select.Item key={`${value}${label}`} value={value}>
            {label}
          </Select.Item>
        ))}
      </Select>
    )}
  />
)

export const StateUSACanada = ({ t, index }) => (
  <FormField
    testId="state"
    type="input"
    name={`addresses[${index}].state`}
    labelText={t('contact-details:state')}
    infoIcon={t('contact-details:state_tooltip')}
    render={(fieldProps) => <Input {...fieldProps} maxlength={2} aria-describedby={`error-${fieldProps.name}`} id={fieldProps.name} required autocomplete="off" />}
  />
)

export const Email = ({ t }) => (
  <FormField
    testId="email"
    type="input"
    name="contactData.email"
    labelText={t('contact-details:email')}
    ariaLabelInfoIcon={t('contact-details:email_tooltip_title')}
    infoIcon={t('contact-details:email_tooltip')}
    render={(fieldProps) => <Input {...fieldProps} aria-describedby={`error-${fieldProps.name}`} id={fieldProps.name} required autocomplete="email" />}
  />
)
export const MobilePhoneNumber = ({ t }) => {
  const { setFieldValue } = useFormikContext()
  return (
    <FormField
      testId="mobilePhoneNumber"
      type="input"
      name="contactData.mobilePhoneNumber"
      labelText={t('contact-details:mobilePhoneNumber')}
      infoIcon={t('contact-details:mobilePhoneNumber_tooltip')}
      ariaLabelInfoIcon={t('contact-details:mobilePhoneNumber_tooltip_title')}
      handleBlur={(e) => {
        if (e?.target?.value) {
          setFieldValue(
            'contactData.mobilePhoneNumber',
            e.target.value?.replace(/\s/g, '')?.replace(/^0+/, '')
          )
        }
      }}
      render={(fieldProps) => <Input {...fieldProps} aria-describedby={`error-${fieldProps.name}`} id={fieldProps.name} required autoComplete='tel-national' />}
    />
  )
}

export const MobilePhoneCountryCode = ({ t }) => (
  <FormField
    testId="mobilePhoneCountryCode"
    type="select"
    name="contactData.mobilePhoneCountryCode"
    labelText={t('contact-details:mobilePhoneCountryCode')}
    render={(fieldProps) => (
      <Select values={phoneCountryCodes} {...fieldProps} required autoComplete='tel-country-code'>
        {phoneCountryCodes.map(({ value, label }) => (
          <Select.Item key={`${value}${label}`} value={value}>
            {label}
          </Select.Item>
        ))}
      </Select>
    )}
  />
)

export const CompanyName = ({ t, index }) => (
  <FormField
    testId="companyName"
    type="input"
    name={`addresses[${index}].companyName`}
    labelText={t('contact-details:companyName')}
    render={(fieldProps) => <Input {...fieldProps} aria-describedby={`error-${fieldProps.name}`} id={fieldProps.name} required autoComplete='organization' />}
  />
)
